module.exports = { apiServer: 'https://hkim-api.win.eventizer.hk', AdminServer: 'https://hkim-admin.win.eventizer.hk' };
